module.exports = __webpack_public_path__ + "media/images/countrysquared/mv-978496b4013e512f577546213105ce35.svg";